import type { GameObj, KEventController } from 'kaplay'
import type { KAPLAYCtx } from '../types.ts'
import { getTiledSize } from '../utils.ts'
import { COLOR_HEX_PURPLE } from '../consts.ts'

export function usePcEasterEggPopup(k: KAPLAYCtx) {

  let popupCloseButtonClickEvent: KEventController
  let objPopup: GameObj
  let isPopupVisible = false

  k.loadSprite('popup', 'sprites/ui-popup-slice9.png', {
    slice9: {
      top: 16,
      bottom: 16,
      left: 16,
      right: 16,
    },
  })

  k.loadSprite('popupBtn', 'sprites/ui-popup-button.png', {
    sliceX: 1,
    sliceY: 2,
  })

  k.loadSprite('easteregg', 'sprites/easteregg-pc.png')

  function showPcEasterEggPopup() {
    if (isPopupVisible) return

    const width = k.width()
    const height = k.height()
    const halfWidth = width / 2
    // const halfHeight = height / 2

    objPopup = k.add([])

    objPopup.add([
      k.rect(k.width(), k.height()),
      k.pos(0, 0),
      k.color(k.Color.fromHex(COLOR_HEX_PURPLE)),
      k.opacity(0.8),
      k.fixed(),
      k.layer('ui'),
      'ui_popup_backdrop',
      'ui_popup',
      'ui',
    ])

    // objPopup.add([
    //   k.sprite('popup', {
    //     width: popupSize.w,
    //     height: popupSize.h,
    //   }),
    //   k.pos(halfWidth, halfHeight),
    //   k.anchor('center'),
    //   k.fixed(),
    //   k.layer('ui'),
    //   'ui_popup_background',
    //   'ui_popup',
    //   'ui',
    // ])

    objPopup.add([
      k.sprite('ui', {
        width: getTiledSize(),
        height: getTiledSize(),
        anim: 'popupCloseBtn',
      }),
      k.pos(
        width - getTiledSize(0.5),
        getTiledSize(0.5),
      ),
      k.anchor('topright'),
      k.fixed(),
      k.area(),
      k.layer('ui'),
      'ui_popup_close_btn',
      'ui_popup',
      'ui',
    ])

    objPopup.add([
      k.sprite('easteregg', {
        width: (height / 3) * 4,
        height: height,
      }),
      k.pos(halfWidth, 0),
      k.anchor('top'),
      k.fixed(),
      k.layer('ui'),
    ])

    popupCloseButtonClickEvent = k.onClick('ui_popup_close_btn', () => {
      hidePcEasterEggPopup()
    })

    isPopupVisible = true
  }

  function hidePcEasterEggPopup() {
    popupCloseButtonClickEvent.cancel()
    k.destroy(objPopup)
    isPopupVisible = false
  }

  return {
    showPcEasterEggPopup,
    hidePcEasterEggPopup,
  }
}
